module.exports = __webpack_public_path__ + "img/burner-mining-drill-N-shadow.5da54462.png";